"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("./context");
const react_hanger_1 = require("react-hanger");
exports.OsmosysModalProvider = ({ children }) => {
    const { state, setState } = react_hanger_1.useSetState({});
    const updaters = react_1.useMemo(() => {
        return {
            close: () => { },
            onClose: () => { },
            onOpen: () => { },
            open: () => { },
            toggle: () => { },
        };
    }, [setState]);
    return (react_1.default.createElement(context_1.OsmosysModalUpdateContext.Provider, { value: updaters },
        react_1.default.createElement(context_1.OsmosysModalDataContext.Provider, { value: state }, children)));
};
//# sourceMappingURL=OsmosysModalProvider.js.map